<crm-multi-select
  [filtersUiVersion]="filtersUiVersion"
  #multiSelectComponent
  [options]="deals"
  [(selectedItems)]="_selectedDeals"
  (selectedItemsChange)="onSelect($event)"
  (panelShow)="onShowPanel()"
  (onFilter)="searchDeal($event.filter)"
  [showToggleAll]="true"
  [virtualScroll]="true"
  [virtualScrollItemSize]="87"
  [class]="class + (isError ? ' ng-invalid ng-dirty' : '')"
  [styleClass]="styleClass + (isError ? ' ng-invalid ng-dirty' : '')"
  [disabled]="disabled"
  [appendTo]="appendTo"
  [showClear]="showClear"
  [label]="label"
  [placeholder]="placeholder"
  [panelStyle]="panelStyle"
  [panelStyleClass]="panelStyleClass"
  [loading]="selectionLoading"
  [filterBy]="customSearch ? 'name,contragent.name,number,dealCode' : 'serverFilterPass'">
  <ng-template
    #selectedItemsTemplate
    let-deals="items">
    <ng-container *ngFor="let deal of deals; last as isLast">
      <ng-container *ngIf="toDeal(deal) as deal">
        <span [innerHTML]="highlightMatchText(deal.name) | truncate: 70 | safeHtml"></span>
        {{ isLast ? '' : ', ' }}
      </ng-container>
    </ng-container>
  </ng-template>
  <ng-template
    #itemTemplate
    let-deal="item">
    <ng-container *ngIf="toDeal(deal) as deal">
      <div class="crm-deal-multi-select-item w-full flex justify-content-between align-items-start gap-3">
        <div class="crm-deal-multi-select-item__body flex-1 min-w-0">
          <p
            class="font-medium text-black m-0"
            [ngClass]="itemStyleClass">
            <span class="white-space-nowrap">Сделка ФРМ-{{ deal.number }}</span>
          </p>
          <p class="text-gray-500 text-sm m-0 mt-1">
            <span [innerHTML]="highlightMatchText(deal.name) | safeHtml"></span>
          </p>
          <p class="font-medium text-gray-500 m-0 mt-1">{{ deal.contragent?.name }}</p>
          <p class="font-bold text-green-500 m-0 mt-1">{{ deal.amount | number: '.0-0' }}</p>
        </div>
        <div
          *ngIf="isShowStatus"
          class="crm-deal-multi-select-item__status flex-shrink-0 white-space-nowrap">
          <crm-status-label
            *ngIf="deal.status"
            [name]="deal.status.name"
            [color]="deal.status.color"></crm-status-label>
        </div>
      </div>
    </ng-container>
  </ng-template>

  <ng-template #footerTemplate>
    <crm-spinner
      *ngIf="paginationLoading"
      top=""
      text=""
      [height]="35"
      [width]="35"
      bottom=""></crm-spinner>
  </ng-template>
</crm-multi-select>
